import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { SnackbarProvider } from 'notistack'
import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import DateFnsUtils from "@date-io/date-fns"
import huLocale from "date-fns/locale/hu"
import { Button } from '@material-ui/core'

// add action to all snackbars
const notistackRef = React.createRef();
const onClickDismiss = key => () => {
  notistackRef.current.closeSnackbar(key);
}

document.title = process.env.REACT_APP_TITLE

ReactDOM.render(
  <React.StrictMode>
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={huLocale}>
      <SnackbarProvider
        autoHideDuration={5} maxSnack={4}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        ref={notistackRef}
        action={(key) => (
          <Button onClick={onClickDismiss(key)}>
            OK
          </Button>
        )}>
        <App />
      </SnackbarProvider>
    </MuiPickersUtilsProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
